import { Injectable } from '@angular/core';

import { SimpleGridConfigService } from '../../../grids/services/simple-grid-config.service';

@Injectable()
export class BigWTableGridConfigService extends SimpleGridConfigService {}
